define('rebrush/components/blocks/varnish/esi',[
    'jquery',
    'lodash',
    'cartware/components/_base',
    'cartware/jquery/bem'
], function(
    $,
    _,
    Component,
    BEM
) {
    return Component.create({

        $init: function() {

            const esiUrl = gigaset.varnish.esi_url || null;

            if (!esiUrl) {
                return;
            }

            // the whole purpose of this is to create the varnish cookie session
            new Ajax.Request(esiUrl, {
                onSuccess: function(response) {}
            });
        }
    });
});

